/**
 * @generated SignedSource<<b581c00b27c108d3bc460f4db6054b35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingConnectionFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly cursor: string;
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"SettingFragment">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly pageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"PageInfoFragment">;
  } | null | undefined;
  readonly structure: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"StructureFragment">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "SettingConnectionFragment";
};
export type SettingConnectionFragment$key = {
  readonly " $data"?: SettingConnectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingConnectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Setting",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SettingFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Structure",
      "kind": "LinkedField",
      "name": "structure",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StructureFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PageInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SettingConnection",
  "abstractKey": null
};

(node as any).hash = "3c82f45066acdc71c491cd5cbf4de435";

export default node;
